<template>
  <form-inspection-list :is-confirmed-page="true" />
</template>
<script>
import FormInspectionList from '@/components/FormComponents/InspectionList'

export default {
  components: {
    FormInspectionList,
  },
}
</script>
